import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { of, switchMap } from 'rxjs';
import { PageRegisterComponent } from '../../amm-pages/page-register/page-register.component';
import { AuthService } from '../services';
import { APPCONSTANT } from '../constants';

export const forceLoginGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const dialogService = inject(DialogService);
  const router = inject(Router);
  
  if (authService.isLoggedIn()) return of(true);

  // 本地还留着已过期的 token 时先清掉,再走登录流程
  authService.expireSession();

  const isSmallSize: boolean = window.innerWidth <= APPCONSTANT.SMALL_SIZE_WIDTH;
  if (isSmallSize) {
    return router.navigate(['/mobile-register']);
  } 
  
  const ref = dialogService.open(PageRegisterComponent, {
    showHeader: false,
    width: '760px',
    style: {
      padding: '0px',
      'border-radius': '24px',
      width: '760px',
      'min-height': '532px',
    },
    contentStyle: {
      overflow: 'visible',
      padding: '0px',
      'border-radius': '24px',
      width: '760px',
      'min-height': '532px',
    },
    breakpoints: {
      '760px': '95vw',
    },
  });

  return ref.onClose.pipe(switchMap((x) => of(authService.isLoggedIn())));

};
